<template>
	<div
		class="app-card"
		:class="cardType"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
	computed: {
		cardType () {
			return this.$attrs.type ? `app-card--${this.$attrs.type}` : ''
		}
	}
}
</script>

<style lang="scss" scoped>
.app-card {
	padding: 10px;
	border-radius: 3px;
	box-shadow: inset 0 0 3px $default-light;
	background-color: #fff;

	&--primary { border-top: 10px solid $primary; }
}
</style>
